import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  is_not_deleted: Types.Scalars['Boolean']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', users_by_pk: Array<{ __typename?: 'users', id: string, first_name: string, last_name: string, email: string, phone_number?: string | null, profile_photo?: string | null, created_at?: any | null, last_seen?: any | null, is_admin?: boolean | null, role?: string | null, title?: string | null, brief_email_frequency: string, workspace_id?: any | null, organization_id?: any | null, workspace?: { __typename?: 'workspaces', id: any, logo?: string | null, name: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null, display_price?: boolean | null, jurisdiction_id?: any | null, nav_profile?: string | null, jurisdiction?: { __typename?: 'jurisdictions', id: any, name: string, short_name: string, state: string, ahj_type: string } | null } | null, user_properties: Array<{ __typename?: 'user_properties', id: any, user_id: string, property_id: any, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, photo_link?: string | null, organization_id: any, workspace_id?: any | null, warranty_start_date?: any | null, warranty_expiration_date?: any | null, warranty_document_id?: any | null, building_type?: string | null, expected_device_type?: any | null, tier_status?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null } | null }>, user_organizations: Array<{ __typename?: 'organizations_users', id: any, organization_id: any, user_id: string, created_at?: any | null, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null }> }> };


export const GetUserByIdDocument = gql`
    query getUserById($id: String!, $is_not_deleted: Boolean!) {
  users_by_pk: users(
    where: {id: {_eq: $id}, deleted_at: {_is_null: $is_not_deleted}}
  ) {
    id
    first_name
    last_name
    email
    phone_number
    profile_photo
    created_at
    last_seen
    is_admin
    role
    title
    brief_email_frequency
    workspace_id
    workspace {
      id
      logo
      name
    }
    organization_id
    organization {
      id
      name
      type
      organizationImageURL
      display_price
      jurisdiction_id
      nav_profile
      jurisdiction {
        id
        name
        short_name
        state
        ahj_type
      }
    }
    user_properties {
      id
      user_id
      property_id
      property {
        id
        name
        address
        address_id
        standardized_address {
          id
          street_1
          street_2
          city
          state
          postal_code
          country
        }
        premium
        photo_link
        organization_id
        workspace_id
        warranty_start_date
        warranty_expiration_date
        warranty_document_id
        building_type
        expected_device_type
        tier_status
        organization {
          id
          name
          type
          organizationImageURL
        }
      }
    }
    user_organizations {
      id
      organization_id
      user_id
      created_at
      organization {
        id
        name
        type
        organizationImageURL
      }
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      is_not_deleted: // value for 'is_not_deleted'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> & ({ variables: GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;